(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858],{

/***/ 58305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-list",
      function () {
        return __webpack_require__(90652);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96306);
/* harmony import */ var _components_CompanyListPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13448);




var CompanyDetailPage = function(props) {
    var jsToken = props.jsToken, wsToken = props.wsToken, user = props.user, appMode = props.appMode, companyList = props.companyList, _keyword = props.keyword, keyword = _keyword === void 0 ? "" : _keyword, _industries = props.industries, industries = _industries === void 0 ? [] : _industries, seoKeywords = props.seoKeywords;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_store__WEBPACK_IMPORTED_MODULE_2__.AppStoreProvider, {
        langCode: _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.EN */ .Df.EN,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CompanyListPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            seoKeywords: seoKeywords,
            jsToken: jsToken,
            wsToken: wsToken,
            companyList: companyList,
            keywordFromUrl: keyword,
            industriesFromUrl: industries,
            langCode: _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.EN */ .Df.EN,
            user: user,
            appMode: appMode
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CompanyDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,775,239,572,425,61,448,452,588,774,888,179], function() { return __webpack_exec__(58305); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);